import { FC } from 'react';
import { Divider, HStack, Text, VStack } from '@chakra-ui/react';

import SunshineCard from 'components/_core/SunshineCard';

import locales from './locales';

interface SecondaryOptionsProps {
  onSkip: () => void;
  onGoCapitalDeposit: () => void;
}

const SecondaryOptions: FC<SecondaryOptionsProps> = ({
  onGoCapitalDeposit,
  onSkip,
}) => (
  <VStack align="stretch" mx="auto" spacing="space-24">
    <HStack
      alignItems="center"
      alignSelf="center"
      spacing="space-16"
      width="300px"
    >
      <Divider flexGrow={1} />

      <Text size="sm" variant="light">
        {locales.separatorOr}
      </Text>

      <Divider flexGrow={1} />
    </HStack>

    <SunshineCard.Group isBoxed={false} marginBottom="space-40">
      <SunshineCard onClick={onSkip} title={locales.enterDetailsManually}>
        <SunshineCard.Slot name="action">
          <SunshineCard.SunshineIcon name="chevron-right" />
        </SunshineCard.Slot>
      </SunshineCard>

      <SunshineCard
        onClick={onGoCapitalDeposit}
        title={locales.goCapitalDeposit}
      >
        <SunshineCard.Slot name="action">
          <SunshineCard.SunshineIcon name="chevron-right" />
        </SunshineCard.Slot>
      </SunshineCard>
    </SunshineCard.Group>
  </VStack>
);

export default SecondaryOptions;
